type DiagnosticStatus = PconDiagnosticsSnapshot['status'];

function buildSnapshot(
    status: DiagnosticStatus,
    stage: string,
    detail?: Record<string, unknown>
): PconDiagnosticsSnapshot {
    return {
        status,
        stage,
        detail,
        updatedAt: new Date().toISOString(),
    };
}

export function updateDiagnostics(
    status: DiagnosticStatus,
    stage: string,
    detail?: Record<string, unknown>
): PconDiagnosticsSnapshot {
    const snapshot = buildSnapshot(status, stage, detail);
    window.__PCON_DIAGNOSTICS__ = snapshot;
    window.dispatchEvent(new CustomEvent('pcon:status', { detail: snapshot }));
    window.dispatchEvent(new CustomEvent(`pcon:${stage}`, { detail: snapshot }));
    return snapshot;
}

export function reportBootStage(stage: string, detail?: Record<string, unknown>): PconDiagnosticsSnapshot {
    return updateDiagnostics('booting', stage, detail);
}

export function reportBooted(detail?: Record<string, unknown>): PconDiagnosticsSnapshot {
    return updateDiagnostics('booted', 'booted', detail);
}

export function reportViewerReady(detail?: Record<string, unknown>): PconDiagnosticsSnapshot {
    return updateDiagnostics('viewer-ready', 'viewer-ready', detail);
}

export function reportViewerFailure(detail?: Record<string, unknown>): PconDiagnosticsSnapshot {
    return updateDiagnostics('viewer-failed', 'viewer-failed', detail);
}
